import * as d3 from "d3";
import { useEffect } from 'react';

import { toCartesian } from "../../../noncomponents/HelperFunctions"
import getVisibleLinks from "../../../noncomponents/getVisibleLinks"


function Verbindingen({ data, iconPositions, circleWidth, hoverSelection, clickSelection,
  connectionChains, linkPathsPerIcon, chainSelection, circleWidthImpacts }) {

  // this useEffect makes sure the grey links are underneath coloured links
  const greyColor = '#f1f1f1';
  useEffect(() => {
    d3.selectAll('.' + greyColor.replace('#',''))
      .lower()
  })


  var lineGenerator = d3.line()
    .curve(d3.curveBasis);

  const links = getVisibleLinks(hoverSelection, linkPathsPerIcon, clickSelection,
    connectionChains, chainSelection);

  // colors of outgoing and incoming arrows
  const linkColors = ['#f28f2d', '#76b6b3', greyColor];
  // blue color: '#76b6b3'

  return (
    <g className="Verbindingen">
      {links.map(link => {

        const icons = link['link'].split('_to_');
        const points = link['controlPoints'];

        let stroke = linkColors[2];
        if(+icons[0] === hoverSelection || +icons[0] === clickSelection){
          stroke = linkColors[1];
        }else if(+icons[1] === hoverSelection || +icons[1] === clickSelection){
          stroke = linkColors[0]
        }

        let markerURL = "url(#arrow_";
        if(data.filter(d => d.ID === icons[1])[0].typenr === '4'){
          markerURL += 'impact_'
        }
        markerURL += stroke + ")"

        const cartesianPoints = toCartesian(points);

        // JSX
        return (

          <g key={icons[0] + "_to_" + icons[1]}
            className={'link_' + icons[0] + '_to_' + icons[1] + ' ' + stroke.replace('#','')}>
            <path
              d={lineGenerator(cartesianPoints)}
              fill='none'
              stroke={stroke}
              strokeWidth='2'
              markerEnd={markerURL}
              opacity='1'
              pointerEvents='none'
            />
          </g>
        )

      })}

      {/* to define a marker for an arrow point */}
      <defs>
        {linkColors.map(color => {
          return (
            <g key={color} >
              <marker id={"arrow_" + color} viewBox="0 0 10 10" refX={circleWidth/2+8.5} refY="5"
                  markerWidth="5" markerHeight="5"
                  orient="auto-start-reverse" fill={color}>
                <path d="M 0 0 L 10 5 L 0 10 z" />
              </marker>
              <marker id={"arrow_impact_" + color} viewBox="0 0 10 10" refX={circleWidthImpacts/2+9.5} refY="5"
                  markerWidth="5" markerHeight="5"
                  orient="auto-start-reverse" fill={color}>
                <path d="M 0 0 L 10 5 L 0 10 z" />
              </marker>
            </g>
          )
        })}
      </defs>

    </g>
  );
}

export default Verbindingen;
